import type { IconData } from '@stacksjs/iconify-core'

export const eyeOptic: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M2.8 26.901a3.37 3.37 0 0 1 0-1.802C5.38 15.815 13.894 9 24 9s18.62 6.814 21.2 16.099c.163.59.163 1.212 0 1.802C42.62 36.185 34.106 43 24 43S5.38 36.186 2.8 26.901\"/><path d=\"M34 26c0 5.523-4.477 10-10 10s-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10M24 9V2m-9.5 9.082L11 5.02m22.5 6.062L37 5.02M6.979 16.983l-4.95-4.95m38.992 4.948l4.95-4.95\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default eyeOptic
